import { api } from '@/core/lib/api-client';
import { ResponseType } from '@link-in-bio/domain';

export const connectGoogle = (): Promise<ResponseType<string>> => {
  return api.get('/google-oauth/connect');
};
